import { render, staticRenderFns } from "./detailTable9.vue?vue&type=template&id=5e3f4fee&scoped=true"
import script from "./detailTable9.vue?vue&type=script&lang=js"
export * from "./detailTable9.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e3f4fee",
  null
  
)

export default component.exports